import generatePDF, { Options } from "react-to-pdf";
import Layout from "../assets/images/certificate.png";
import { useEffect, useState } from "react";
import {
  formatDateWithCurrentYear,
  FormatEndDate,
  getCertificateData,
} from "../utils/constants";
import { useNavigate, useParams } from "react-router-dom";
import UserService from "../services/user.service";

const PreviewDownloadCertificate = () => {
  const [clicked, setClicked] = useState(false);
  const [loading, setLoading] = useState(false);
  const [data, setData] = useState<any>({});
  const navigate = useNavigate();
  const userService = new UserService();
  const { id } = useParams();

  useEffect(() => {
    getProgram();
    setClicked(true);
  }, []);

  const getProgram = async () => {
    setLoading(true);
    try {
      const response = await userService.getProgramsCertificateData(Number(id));
      setLoading(false);
      if (!response.status) {
        return;
      }
      const data = response.data;
      const CertificateData = {
        name: data.child.firstName + " " + data.child.lastName,
        title: data.child.curriculum === 1 ? data.package.name : !data.package.nameOld ? data.package.name : data.package.nameOld,
        date: FormatEndDate(data.endClassDate),
      };
      setData(CertificateData);
    } catch (err) {
      setLoading(false);
      return;
    }
  };

  // Helper function to get current date as string
  const getCurrentDateString = () => {
    return new Date().toISOString().split('T')[0];
  };

  const options: Options = {
    filename: data.name + "-" + data.title,
    page: {
      margin: 0,
      format: "A4",
      orientation: "landscape",
    },
    overrides: {
      pdf: {
        compress: true
      }
    }
  };

  const getTargetElement = () => document.getElementById("certificate-container");

  const downloadPdf = () => generatePDF(getTargetElement, options);

  return (
    <>
      <center>
        <button
          className="m-5 flex items-center gap-x-2 px-5 py-3 text-[14px] rounded-[10px] hover:cursor-pointer bg-ryd-primary text-white"
          onClick={downloadPdf}
          disabled={loading}
        >
          {loading ? "Loading..." : "Download as PDF"}
        </button>
      </center>
      
      <div id="certificate-container" className="certificate-wrapper">
        <div className="certificate">
          <img src={Layout} className="certificate-background" alt="Certificate Background" />
          <div className="certificate-content">
            <h2 className="certificate-name">
              {data.name || "Recipient Name"}
            </h2>
            <h1 className="certificate-title">
              <b>{data.title || "Course Title"}</b>
            </h1>
            <div className="certificate-date">
             <b> {data.date || formatDateWithCurrentYear(getCurrentDateString())}</b>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default PreviewDownloadCertificate;